export const banner = require("../src/Assets/333.jpg");
export const banner2 = require("../src/Assets/111.jpg");
export const banner3 = require("../src/Assets/222.jpg");
export const banner4 = require("../src/Assets/444.jpg");
export const banner5 = require("../src/Assets/555.jpg");
export const logo = require("../src/Assets/Logo.png");
export const aLogo = require("../src/Assets/amazonlogo.png");
export const Flogo = require("../src/Assets/flipkartlogo.png");
export const WhatsAppLogo= require("../src/Assets/WhatsappLogo.png");
export const breakLine=require('../src/Assets/break-line.png');
export const About=require('../src/Assets/darkenImg.png');
export const Gallery1=require('../src/Assets/kamdhenu-table-view.png');
export const Project1=require('../src/Assets/Narhe_project.png');
export const Project2=require('../src/Assets/Kirkatwadi_project.png');
export const Project3=require('../src/Assets/Wagholi_project.png');
export const gallery1=require('../src/Assets/galleryImg1.jpeg');
export const gallery2=require('../src/Assets/galleryImg2.jpeg');
export const gallery3=require('../src/Assets/galleryImg3.jpg');
export const gallery4=require('../src/Assets/galleryImg4.jpeg');